import {useState} from 'react';
import {Box, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip} from '@mui/material';
import PaletteOutlinedIcon from '@mui/icons-material/PaletteOutlined';
import CheckIcon from '@mui/icons-material/Check';
import {appThemeOptions, AppThemeId} from '@mybake/ui/theme';
import {useAppTheme} from '../../context/AppThemeContext';
import {useAppTranslation} from '@mybake/ui/hooks/useAppTranslation';

export const ThemeSwitcher = () => {
    const {t} = useAppTranslation();
    const {themeId, setThemeId} = useAppTheme();
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

    const selectTheme = (nextThemeId: AppThemeId) => {
        setThemeId(nextThemeId);
        setAnchorEl(null);
    };

    return (
        <>
            <Tooltip title={t('common:color_scheme')}>
                <IconButton
                    aria-label={t('common:color_scheme')}
                    aria-controls={anchorEl ? 'theme-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={anchorEl ? 'true' : undefined}
                    onClick={event => setAnchorEl(event.currentTarget)}
                    size="small"
                >
                    <PaletteOutlinedIcon/>
                </IconButton>
            </Tooltip>
            <Menu
                id="theme-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
                disableScrollLock
                anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                transformOrigin={{vertical: 'top', horizontal: 'right'}}
                PaperProps={{sx: {mt: 0.75, minWidth: 240}}}
            >
                {appThemeOptions.map(option => (
                    <MenuItem key={option.id} selected={themeId === option.id} onClick={() => selectTheme(option.id)}>
                        <ListItemIcon>
                            <Box sx={{width: 20, height: 20, borderRadius: '50%', bgcolor: option.color, border: '1px solid', borderColor: 'divider'}}/>
                        </ListItemIcon>
                        <ListItemText>{t(option.labelKey)}</ListItemText>
                        {themeId === option.id && <CheckIcon color="primary" fontSize="small"/>}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};
